export const CONFIG_STALE_TIME = 1000 * 60 * 60; // 1 hour
